import { getOr } from 'lodash/fp';

const calculateTaxFail = (state, { designId, tax }) => ({
  ...state || {},
  designs: {
    ...getOr({}, 'designs')(state),
    [designId]: {
      ...getOr({}, `designs.${designId}`)(state),
      tax,
    },
  },
});

export default calculateTaxFail;
